import React, { useEffect, useState } from "react";
import { useAtom, useAtomValue } from "jotai";
import { selectedValuesAtom, shouldGenerateIPAPhonemeAtom } from "atoms";
import { useTTS } from "shared/hooks/useTTS";
import PronunciationTabTemplate from "./components/PronunciationTabTemplate";

interface PronunciationMenuIPAProps {
  selectedWord: string;
  userPhoneme: string;
  setPhoneme: React.Dispatch<React.SetStateAction<string>>;
}

function PronunciationMenuIPA({
  selectedWord,
  userPhoneme,
  setPhoneme,
}: PronunciationMenuIPAProps): JSX.Element {
  const selectedValues = useAtomValue(selectedValuesAtom);
  const [selectedLanguage, setSelectedLanguage] = useState<string>(
    selectedValues.selectedLanguage
  );
  const [shouldGenerateIPAPhoneme, setShouldGenerateIPAPhoneme] = useAtom(
    shouldGenerateIPAPhonemeAtom
  );
  const { getPhonemeText } = useTTS();
  const handleRegenerateClick = async () => {
    const input = `<speak><lang language="${selectedLanguage}">${selectedWord}</lang></speak>`;
    try {
      const phoneme = await getPhonemeText(input);
      setPhoneme(phoneme);
    } catch (e) {
      // eslint-disable-next-line no-console
      console.log(e);
    }
  };

  useEffect(() => {
    async function regenerateOnLoad() {
      await handleRegenerateClick();
    }
    if (shouldGenerateIPAPhoneme) {
      if (selectedWord) regenerateOnLoad();
      setShouldGenerateIPAPhoneme(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shouldGenerateIPAPhoneme]);

  const handleLanguageChange = (newLanguage: string) => {
    setSelectedLanguage(newLanguage);
  };

  return (
    <PronunciationTabTemplate
      isIPA
      selectedWord={selectedWord}
      userPhoneme={userPhoneme}
      setPhoneme={setPhoneme}
      selectedLanguage={selectedLanguage}
      handleLanguageChange={handleLanguageChange}
      handleRegenerateClick={handleRegenerateClick}
    />
  );
}

export default PronunciationMenuIPA;
